<template>
    <div class="row">
        <content-filter
            v-if="getTypeStore"
                :id="listName + 'metafilter'"
                @filter="filtering"
                :type="'miniFilter'"
                class="mb-3 col-12"
                :limit-to-organization-ids="[organizationId]"
                :org-filtering="!!organizationId"
                :store-name="getTypeStore"
                :category-filter-items="getMediaCategories()"
                :category-filter-values="getMediaCategoryValues()"
                :category-filter-pre-selected-values="getMediaCategories()"
                :type-filter-items="subType ? [subType] : null"
                :initial-type-filter="subType ? [subType] : null"
        />
        <pagination
                class="col-12"
                :limit="paginationLimit"
                :total="$store.getters['get' + getTypeStore + 'ListOptions'](listName, 'pagination_items')"
                :id="listName"
                @setActive="loadPaginatedData"
        />
        <div :class="[thumbnailView ? 'col-12 col-md-5' : 'col-12']"
          :key="item.id"
          v-for="item in $store.getters['get' + getTypeStore + 'sByListName'](listName)"
          >
            <!--v-if="(!teams || !teams.length) || (item && item.teams && item.teams.filter(team => {return teams.includes(team.id)}).length)"-->
            <div :class="['item-chooser mb-3', item.id === value ? 'selected' : '']" :key="item.id + 'item'" @click="save(item.id)">
                <preview
                        :class="['mb-1', thumbnailView ? 'thumbnail' : 'medium-thumbnail']"
                        :asset-or-project-id="value"
                        v-if="showPreview"
                        :preview-uri="item.previewUri"
                        :type="'image'"
                        :preview-id="item.id"
                        :removable="false"
                />
                <div :class="[thumbnailView ? 'too-long-text-break' : '']">{{ item.name }}</div>
                <div class="lighter">{{ $t('teams') }}:</div>
                <span :key="index" v-for="(team, index) in item.teams">
                  {{ team.displayName }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentFilter from "../filter/ContentFilter";
    import Pagination from "../../Pagination";
    import {MetaFieldStores} from '../../../enum';
    import Preview from "../../preview/Preview";
    import {mediaCategories} from '@/enum';


    /**
     * An item selection list
     * @displayName Content List
     */
    export default {
        name: "ContentList",
        components: {
            ContentFilter,
            Pagination,
            Preview
        },
        props: {
            /**
             * The selected item id
             * @values item-ID
             */
            value: {type: String, default: null},
            /**
             * The type to be listed
             * @values feed, table, dataset, project, app, scene, model, assembly, node, media
             */
            type: {type: String, default: ''},
            /**
             * The list name used in the corresponding store (if multiple content lists on a page, make sure it is a unique identifier)
             * @values any string, usually the id of the linking item
             */
            listName: {type: String, required: true},
            /**
             * The ID of the organization from which the contents should be listed
             */
            organizationId: {type: String,  default: ''},
            /**
            * The team ID's as an array if it should be filtered
            * */
            teams: {type: Array, default: null},
            /**
             * Whether to display a preview or not (if the content type doesn't have a preview property, it will be black)
             * @values true or false
             */
            showPreview: {type: Boolean, default: false,},
            /**
             * Whether to display as thumbnails or not
             * @values true or false
             */
            thumbnailView: {type: Boolean, default: false,},
            /**
             * When pagination is displayed how many items per page
             * @values {Number}
             */
            paginationLimit: {type: Number, default: 10},
            mediaCategory: {type: Number, default: null,},
        },
        data() {
            return {
                storeType: null,
                queryRelevantComponents: 2, //pagination and filter
                queryRelevantInits: 0,
                getTypeStore: '',
                subType: '',
                offset: 0,
                filter: {},
                mediaCategories: mediaCategories
            };
        },
        watch: {
            queryRelevantInits: function(newval) {
                if(newval === this.queryRelevantComponents) {
                    this.loadData(false);
                }
            }
        },
        beforeMount() {
            this.setStore();
        },
        methods: {
            getMediaCategories() {
              if(this.mediaCategory) {
                return Object.keys(mediaCategories).filter(key => {return mediaCategories[key] === this.mediaCategory});
              }
              return [];
            },
            getMediaCategoryValues() {
              const cats = this.getMediaCategories();
              if(cats.length) {
                return cats.map(item => {return mediaCategories[item] ? mediaCategories[item] : null});
              }
              return [];
            },
            setStore() {
                if(MetaFieldStores[this.type].name) {
                  this.subType = MetaFieldStores[this.type].subType;
                  this.getTypeStore = MetaFieldStores[this.type].name;
                } else {
                  this.getTypeStore = MetaFieldStores[this.type];
                }
            },
            filtering: function(args, initial) {
              this.filter = args;
              this.loadData(initial);
            },
            loadPaginatedData(offset, initial) {
              this.offset = offset;
              this.loadData(initial);
            },
            loadData(initial = false) {
              this.loading = true;
              let args = {
                  listName: this.listName,
                  keep: {
                    include: ['teams'],
                    listName: this.listName,
                  }
                 }
                  let paginationAddOn = {
                    paging: {
                      [this.listName]: true,
                    },
                    offset: {
                      [this.listName]: this.offset,
                    },
                    limit: {
                      [this.listName]: this.paginationLimit,
                    },
                  };
                  args.add = this.filter && this.filter.add ? {...paginationAddOn, ...this.filter.add } : paginationAddOn;
                  if(this.filter && this.filter.remove) {
                    args.remove = this.filter.remove;
                  }

                if(initial) {
                    this.queryRelevantInits++;
                    this.$store.dispatch('register' + this.getTypeStore + 'QueryParams', args);
                }
                else {
                  this.$store.dispatch('load' + this.getTypeStore + 's', args).then(() => {
                    this.loading = false;
                  });
                }
            },
            save: function(id) {
                /**
                 * Emits the selected id to the parent component
                 * @param value {string} – the item ID
                 */
                this.$emit('save', id);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .item-chooser {
        padding:15px;
        background: $panel-background-color;
        cursor:pointer;
        &:hover, &.selected {
            background: $highlight;
        }
    }
</style>
<docs>
    Vue component examples:

    A media content list with a selected id:
    ```jsx
    <content-list
            value="'234ksdf8234ksdflakdj'"
            type="media"
            list-name="'asdflk4252lkhsadklg'"
            @save="updateMediaLink"
            :organization-id="'asf33141sdlk4252lkhsadklg'"
            :show-preview="true"
    />
    ```
</docs>
